import React from 'react'
import beardShave from '../../../assets/beard_shave.jpg'
import hair_cut from '../../../assets/hair_cut.jpg'
import pic3 from '../../../assets/pic3.jpg'
import logo from '../../../assets/logo.png'
import './Services.css'

const Services = () => {
    return (
        <div className='services' id='what-we-do'>

            <div className='services-container'>
                <div className='services-info'>
                    <img src={logo} alt=''></img>
                    <h1>What We Do?</h1> 
                    <p className='mr-bottom services-what-we-do-para'>We known for providing cool hairstyles combined with a personal high quality service.
                        With experience of more than 50 years the shop brings a unique experience of the barbershops in New York at their best..
                    </p>
                </div>

                <div className='services-grid'>
                    <div className='services-box'>
                        <img src={hair_cut} alt=''></img>
                        <h2>Haircut Styles</h2>
                        <p className='mr-bottom services-para'>We make latest cutting styles and techniques</p>
                        <p className='mr-bottom services-para'>to ensure their specialty in hair styling.</p>
                    </div>
                    <div className='services-box'>
                        <img src={beardShave} alt=''></img>
                        <h2>Beard Trim</h2>
                        <p className='mr-bottom services-para'>We specialize in beard arrangements, here you will</p>
                        <p className='mr-bottom services-para'>find the best brands for beard care.</p>
                    </div>
                  
                    <div className='services-box'>
                        <img src={pic3} alt=''></img>
                        <h2>Hot Shave</h2>
                        <p className='mr-bottom services-para'>We use special shaving cream, a razor, and a hot</p>
                        <p className='mr-bottom services-para'>towel to shave your facial hair.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services
